
import { defineComponent, ref, reactive, toRefs, onMounted, computed, watch, nextTick } from 'vue'
import { DoubleRightOutlined } from '@ant-design/icons-vue'
import router from '@/router/index'
import { useRoute } from 'vue-router'
import Navatop from '@/components/navtop.vue'
import api from '@/api/allApi'
import Table from '@/components/table.vue'
import Nodata from '@/components/page/nodata.vue'
export default defineComponent({
  components: { Table, Nodata },
  props: {
    itemdata: {
      type: Object,
      default: () => {
        return {}
      }
    },
    pageSourceData: {
      type: Object,
      default: () => {
        return {}
      }
    }
  },
  setup(props, context) {
    const pageData: any = reactive({
      data: [],
      columns: [],
      spinning: true
    })
    pageData.columns = [
      {
        title: '交易日期',
        dataIndex: 'time',
        key: 'time',
        width: '100px'
      },
      {
        title: '成交价(元)',
        dataIndex: 'DealPrice',
        key: 'DealPrice',
        width: '92px',
        ellipsis: true
      },
      {
        title: '成交量(股)',
        dataIndex: 'InvolvedSum',
        key: 'InvolvedSum',
        width: '92px',
        ellipsis: true,
        slots: { customRender: 'peopleCount' }
      },
      {
        title: '成交金额(元)',
        dataIndex: 'DealTurnover',
        key: 'DealTurnover',
        width: '100px',
        ellipsis: true,
        slots: { customRender: 'peopleCount' }
      },
      {
        title: '买入营业部',
        dataIndex: 'BuyName',
        key: 'BuyName',
        slots: { customRender: 'ellipsis' },
        width: '200px',
        ellipsis: true
      },
      {
        title: '卖出营业部',
        dataIndex: 'SellName',
        key: 'SellName',
        slots: { customRender: 'ellipsis' },
        width: '200px',
        ellipsis: true
      }
    ]
    watch(
      () => (props.pageSourceData || {}).LargeTran,
      () => {
        const _data = (props.pageSourceData || {}).LargeTran
        if ((_data || []).length) {
          _data.forEach((item: any, i: number) => {
            item.index = 'LargeTran' + i
            item.time = window.moment(item.TradeDay * 1000).format('YYYY-MM-DD')
          })
        }
        nextTick(() => {
          pageData.spinning = false
        })
        pageData.data = _data
      },
      { deep: true }
    )
    return {
      ...toRefs(pageData)
    }
  }
})
